(() => {
  if (window.__omCartNotificationBenefitInitialized) {
    return;
  }

  window.__omCartNotificationBenefitInitialized = true;

  const THRESHOLDS = {
    delivery: 99900,
    om5: 129900,
    om10: 199900,
    om20: 349900
  };

  let refreshTimer = null;
  let observersConnected = false;

  function getNotification() {
    return (
      document.querySelector('cart-notification') ||
      document.querySelector('#cart-notification') ||
      document.querySelector('.cart-notification')
    );
  }

  function formatMoney(paise) {
    const amount = Math.max(
      0,
      Math.ceil(Number(paise || 0) / 100)
    );

    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  }

  function getBenefitMessage(total) {
    if (total < THRESHOLDS.delivery) {
      return (
        `Add ${formatMoney(
          THRESHOLDS.delivery - total
        )} more to unlock complimentary delivery.`
      );
    }

    if (total < THRESHOLDS.om5) {
      return (
        `Complimentary delivery unlocked. Add ${formatMoney(
          THRESHOLDS.om5 - total
        )} more to unlock 5% off.`
      );
    }

    if (total < THRESHOLDS.om10) {
      return (
        `5% off is available with OM5. Add ${formatMoney(
          THRESHOLDS.om10 - total
        )} more to unlock 10% off.`
      );
    }

    if (total < THRESHOLDS.om20) {
      return (
        `10% off is available with OM10. Add ${formatMoney(
          THRESHOLDS.om20 - total
        )} more to unlock 20% off.`
      );
    }

    return '20% off is available with code OM20.';
  }

  function ensureBenefitBlock() {
    const notification = getNotification();

    if (!notification) {
      return null;
    }

    let benefitBlock = notification.querySelector(
      '[data-om-cart-notification-benefit]'
    );

    if (benefitBlock) {
      return benefitBlock;
    }

    const notificationLinks = notification.querySelector(
      '.cart-notification__links'
    );

    if (!notificationLinks || !notificationLinks.parentElement) {
      return null;
    }

    benefitBlock = document.createElement('div');

    benefitBlock.className =
      'om-cart-notification-benefit';

    benefitBlock.setAttribute(
      'data-om-cart-notification-benefit',
      ''
    );

    benefitBlock.innerHTML = `
      <div
        class="om-cart-notification-benefit__icon"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          width="18"
          height="18"
          fill="none"
        >
          <path
            d="M20 12V21H4V12"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linejoin="round"
          ></path>

          <path
            d="M2.5 8H21.5V12H2.5V8Z"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linejoin="round"
          ></path>

          <path
            d="M12 8V21"
            stroke="currentColor"
            stroke-width="1.7"
          ></path>

          <path
            d="M12 8H8.5C6.9 8 6 7.1 6 5.9C6 4.7 6.9 4 8 4C10.2 4 12 8 12 8Z"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linejoin="round"
          ></path>

          <path
            d="M12 8H15.5C17.1 8 18 7.1 18 5.9C18 4.7 17.1 4 16 4C13.8 4 12 8 12 8Z"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linejoin="round"
          ></path>
        </svg>
      </div>

      <p
        class="om-cart-notification-benefit__message"
        data-om-cart-notification-benefit-message
        aria-live="polite"
      ></p>
    `;

    notificationLinks.parentElement.insertBefore(
      benefitBlock,
      notificationLinks
    );

    return benefitBlock;
  }

  function updateBenefit(total) {
    const benefitBlock = ensureBenefitBlock();

    if (!benefitBlock) {
      return;
    }

    const messageElement = benefitBlock.querySelector(
      '[data-om-cart-notification-benefit-message]'
    );

    if (messageElement) {
      messageElement.textContent =
        getBenefitMessage(total);
    }
  }

  async function fetchCart() {
    const root =
      window.Shopify?.routes?.root || '/';

    const response = await fetch(
      `${root}cart.js`,
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Unable to retrieve cart.');
    }

    return response.json();
  }

  async function refreshBenefit() {
    try {
      const cart = await fetchCart();
      updateBenefit(cart.total_price);
    } catch (error) {
      console.error(
        'OM Cart Notification Benefit:',
        error
      );
    }
  }

  function scheduleRefresh(delay = 350) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(
      refreshBenefit,
      delay
    );
  }

  function connectObservers() {
    if (observersConnected) {
      return;
    }

    const notification = getNotification();

    if (!notification) {
      window.setTimeout(connectObservers, 500);
      return;
    }

    observersConnected = true;

    const notificationObserver =
      new MutationObserver(() => {
        scheduleRefresh(120);
      });

    notificationObserver.observe(notification, {
      attributes: true,
      attributeFilter: [
        'class',
        'aria-hidden',
        'open'
      ]
    });

    const productArea =
      notification.querySelector(
        '#cart-notification-product'
      ) ||
      notification.querySelector(
        '.cart-notification-product'
      );

    if (productArea) {
      const productObserver =
        new MutationObserver(() => {
          scheduleRefresh(150);
        });

      productObserver.observe(productArea, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  function initialise() {
    ensureBenefitBlock();
    connectObservers();
    scheduleRefresh(50);
  }

  document.addEventListener(
    'cart:updated',
    () => scheduleRefresh(100)
  );

  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target.closest(
          'button[name="add"], ' +
          '.product-form__submit, ' +
          '.quick-add__submit'
        )
      ) {
        scheduleRefresh(800);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );
  } else {
    initialise();
  }
})();